import { CompanyModule } from '../common/enums/companyModule.enum'
import { ICompany } from '../common/models/Company'
import { CompanyPlan } from '../common/enums/companyPlan.enum'
import {
  getCompanyPlan,
  isModuleEnabled as isSettingsModuleEnabled,
} from '../common/helpers/moduleAccess.helper'
import { useAppState } from '../context/AppContext'

// Company-level convenience wrapper around the shared settings helper (single
// source of the "absent = default" semantic). Kept for navHelper/requestsHelper.
export const isModuleEnabled = (
  company: ICompany | undefined,
  module: CompanyModule
): boolean => isSettingsModuleEnabled(company?.settings, module)

export const useModuleAccess = () => {
  const { company } = useAppState()

  return {
    employerBranding: isModuleEnabled(company, CompanyModule.EMPLOYER_BRANDING),
    onboarding: isModuleEnabled(company, CompanyModule.ONBOARDING),
    performanceManagement: isModuleEnabled(
      company,
      CompanyModule.PERFORMANCE_MANAGEMENT
    ),
    // Advanced engagement: the culture scan. Surveys are on every plan.
    engagement: isModuleEnabled(company, CompanyModule.ENGAGEMENT),
    // Part of performance management: off whenever that is
    journals: isModuleEnabled(company, CompanyModule.JOURNALS),
    // Suite: surveys sent to members, besides the people modules
    isSuite: getCompanyPlan(company?.settings) === CompanyPlan.SUITE,
    isModuleEnabled: (module: CompanyModule) =>
      isModuleEnabled(company, module),
  }
}
